import React from 'react';
import { NetworkAside } from '../shared/components/Aside/NetworkAside';
import { PeopleAside } from '../shared/components/Aside/PeopleAside';
import { useUIState } from '../shared/contexts/UIStateProvider';
import { ChatAside } from './ChatAside';
import { TranscriptionAside } from './TranscriptionAside';

export const Asides = () => {
	const { asides } = useUIState();

	return (
		<>
			<PeopleAside />
			<NetworkAside />
			<ChatAside />
			{/* <TranscriptionAside /> */}
			{asides.map((AsideComponent: any) => (
				<AsideComponent key={AsideComponent.name} />
			))}
		</>
	);
};
